( function ( $ ){ // Self Executing function with $ alias for jQuery

	/**
	 *  Initialization  similar to include once but since all js is loaded by the browser automatically the all
	 *   we have to do is call our functions to initialize them, his is only run in the main configuration file
	 */
	$( document ).ready( function (){
		window.ulgmGroupManagement.restForms.constructor();

		var file_frame;

		var uploadedUsers;

		jQuery( '#ulgm_group_upload_image_button' ).on( 'click', function ( event ){
			event.preventDefault();

			if (file_frame) {

				file_frame.open();
				return;
			}
			// Create the media frame.
			file_frame = wp.media.frames.file_frame = wp.media( {
				title: 'Select a image to upload',
				button: {
					text: 'Use this image',
				},
				multiple: false
			} );
			// When an image is selected, run a callback.
			file_frame.on( 'select', function (){
				attachment = file_frame.state().get( 'selection' ).first().toJSON();
				$( '#ulgm_group_image_preview' ).attr( 'src', attachment.url ).css( 'width', 'auto' ).show();
				$( '#ulgm_group_image_attachment_id' ).val( attachment.id );
			} );

			file_frame.open();
		} );

		jQuery( '#ulgm_group_edit_upload_image_button' ).on( 'click', function ( event ){
			event.preventDefault();

			if (file_frame) {

				file_frame.open();
				return;
			}
			// Create the media frame.
			file_frame = wp.media.frames.file_frame = wp.media( {
				title: 'Select a image to upload',
				button: {
					text: 'Use this image',
				},
				multiple: false
			} );
			// When an image is selected, run a callback.
			file_frame.on( 'select', function (){
				$( '#ulgm_group_edit_image' ).hide();
				attachment = file_frame.state().get( 'selection' ).first().toJSON();
				$( '#ulgm_group_edit_image_preview' ).attr( 'src', attachment.url ).css( 'width', 'auto' ).show();
				$( '#ulgm_group_edit_image_attachment_id' ).val( attachment.id );
			} );

			file_frame.open();
		} );

	} );

	window.ulgmGroupManagement.restForms = {

		// initialize the code
		constructor: function (){

			if (typeof window.ulgmRestApiSetup !== 'undefined') {
				// Add events for the group management page
				this.addFormSubmitEvents();

				try {
					$( '#ulgm_font_color' ).wpColorPicker();
					$( '#ulgm_main_color' ).wpColorPicker();
				} catch (err) {
					// Handle error(s) here
				}
			}
		},

		makeAjaxCall: function ( endPoint, restData, associatedForm ){

			var $title_container = associatedForm.find( '#group-management-title' );

			var $error_container = associatedForm.find( '.group-management-rest-message' );

			var spinner = $( '.uo-modal-spinner' );

			if ('upload_users' === endPoint) {
				uploadedUsers++;
				restData.uploaded_users = uploadedUsers;
			}


			var _this = this;

			$.ajax( {

				method: "POST",
				url: ulgmRestApiSetup.root + endPoint + '/',
				data: restData,

				// Attach Nonce the the header of the request
				beforeSend: function ( xhr ){
					xhr.setRequestHeader( 'X-WP-Nonce', ulgmRestApiSetup.nonce );
				},

				statusCode: {
					403: function ( response ){
						spinner.hide();
						$error_container.html( ulgmRestApiSetup.i18n.youCantDoThat ).show();
					}
				},

				success: function ( response ){

					spinner.hide();

					if (true === response.success) {

						$( '#uo-group-report-course' ).show();
						$error_container.hide();

						var url = window.location.href;

						//append rest message to url
						if (url.indexOf( '?' ) > -1) {
							url += '&message=' + encodeURIComponent( response.data.message );
						} else {
							url += '?message=' + encodeURIComponent( response.data.message );
						}

						if (typeof response.data.reload === 'undefined') {

							var name  = 'message';
							var value = response.data.message;

							var str = location.search;
							if (new RegExp( "[&?]" + name + "([=&].+)?$" ).test( str )) {
								str = str.replace( new RegExp( "(?:[&?])" + name + "[^&]*", "g" ), "" )
							}
							str += "&";
							str += name + "=" + value;
							str = "?" + str.slice( 1 );

							// there is an official order for the query and the hash if you didn't know.
							location.assign( location.origin + location.pathname + str + location.hash );

						} else if (typeof response.data.call_function !== 'undefined') {

							if (typeof response.data.function_vars !== 'undefined') {
								window.ulgmGroupManagement[response.data.call_function]( response.data.function_vars );
							} else {
								window.ulgmGroupManagement[response.data.call_function]();
							}

						} else if (
							typeof response.data.reload !== 'undefined' &&
							typeof response.data.endpoint !== 'undefined' &&
							response.data.reload === false &&
							( response.data.endpoint === 'upload_users' || response.data.endpoint === 'send-enrollment' )
						) {

							if( 1 === response.data.uploaded_users ){
								// first time the upload ran
								$([document.documentElement, document.body]).animate({
									scrollTop: $("#group-management-users").offset().top
								}, 2000);

								// Hide modal
								$( "#group-management-upload-users .uo-close-modal" ).click();
								// Show CSV log
								$( '#uo-groups-upload-summary' ).show();
								// Hide Users table to force page reload
								$( '.uo-groups-group-courses' ).hide();
								$( '.uo-groups-enrolled-users' ).hide();
								$( '#group-management-leaders' ).hide();
							}




							// Set summary info in heading
							$( '#uo-groups-upload-summary .uo-header-subtitle' ).text( response.data.message );
							$( '#csv-result-total' ).text( response.data.total_rows );

							console.log( 'this is the upload' );
							console.log( response );

							let results = response.data.results;
							results.forEach( function ( entry ){

								let row = document.createElement( 'div' );
								row.setAttribute( "class", "uo-row uo-table-content uo-tbl-item body-row" );

								let emailCol = document.createElement( 'div' );
								emailCol.setAttribute( "class", "content-leaders-email uo-table-cell uo-table-cell-3" );

								let statusCol = document.createElement( 'div' );
								statusCol.setAttribute( "class", "content-leaders-statu uo-table-cell uo-table-cell-7" );

								emailCol.innerText  = entry.email;
								statusCol.innerText = ( 'use_error_code' === entry.status.reason ) ? entry.message : entry.status.reason;

								row.appendChild( emailCol );

								row.appendChild( statusCol );

								let resultsDiv = document.getElementById( 'uo-groups-upload-result-rows' );

								if (null !== resultsDiv) {
									resultsDiv.appendChild( row );

									// new_created_added_to_group, new_failed, existing_added_to_group, existing_already_member, existing_failed

									if ('new_created_added_to_group' === entry.status.user ||
										'existing_added_to_group' === entry.status.user) {
										$( '#csv-result-added' ).text( parseInt( $( '#csv-result-added' ).text() ) + 1 );
									}

									if ('existing_already_member' === entry.status.user) {
										$( '#csv-result-member' ).text( parseInt( $( '#csv-result-member' ).text() ) + 1 );
									}

									if ('new_failed' === entry.status.user ||
										'existing_failed' === entry.status.user) {
										$( '#csv-result-unprocessed' ).text( parseInt( $( '#csv-result-unprocessed' ).text() ) + 1 );
									}
								}
							} );

							if (false === response.data.completed) {
								spinner.show();
								ulgmGroupManagement.restForms.makeAjaxCall( endPoint, restData, associatedForm );
							}
						}


					} else {
						spinner.hide();

						if (ulgmRestApiSetup.hasOwnProperty( 'localized' )) {
							if ('invalid-course-id' !== response.data.error) {
								$( '#uo-group-report-course' ).empty().append(
									$( '<option>', {
										value: '0',
										text: ulgmRestApiSetup.localized.selectCourse
									} )
								);
							}
						}

						$error_container
							.html( response.data.message )
							.show();
					}
				},

				fail: function ( response ){
					spinner.hide();
					$error_container.html( response.data.message );
				}

			} );
		},

		addFormSubmitEvents: function (){

			// Add rest call to all link with a rest call attached
			$( '.submit-group-management-form' ).on( 'click', this.sendRestCall );

			// Add rest call to all link with a rest call attached
			$( '.change-group-management-form' ).on( 'change', this.sendRestCall );

			// Add rest call to all inputs of modal if enter is pressed
			$( '.group-management-modal input' ).on( 'keypress', this.sendRestCall );

			$( 'input[type=radio][name=action]' ).on( 'change', function (){
				var selected_value = this.value;
				if (selected_value === 'add-invite') {
					$( '#uo-import-user-note' ).show();
				} else if (selected_value === 'send-enrollment') {
					$( '#uo-import-user-note' ).hide();
				}
			} );
		},

		sendRestCall: function ( e ){

			var _currentTarget = e.currentTarget;

			// if the current target is a input then we assume the user pressed enter
			if ($( _currentTarget ).is( 'input' )) {
				if (e.key !== "Enter") {
					// Do more work
					return true;
				}
				// switch current target to the forms submit button to extract needed data
				let _associatedForm = $( _currentTarget ).closest( '.group-management-form' );
				// Enter is only pressed inside th modal window
				_currentTarget      = _associatedForm.find( '.submit-group-management-form' );
			}

			var spinner = $( '.uo-modal-spinner' );

			// The form or container of the input data
			var associatedForm   = $( _currentTarget ).closest( '.group-management-form' );
			var $error_container = associatedForm.find( '.group-management-rest-message' );
			$error_container.hide();
			$( '#uo-group-progress-report' ).hide();

			// Get the end point for the rest call from the clicked element
			var endPoint = $( _currentTarget ).data( 'end-point' );

			if (typeof endPoint === 'undefined') {
				return false;
			}

			if (endPoint == 'add_user') {
				document.getElementById( "group-management-add-user-frm" ).onsubmit = function ( e ){
					e.preventDefault();
					return false;
				}
				if (!document.getElementById( "group-management-add-user-frm" ).checkValidity()) {
					document.getElementById( "group-management-add-user-frm" ).reportValidity();
					return;
				}
			}

			if (endPoint == 'edit_user') {
				document.getElementById( "group-management-edit-user-frm" ).onsubmit = function ( e ){
					e.preventDefault();
					return false;
				}
				if (!document.getElementById( "group-management-edit-user-frm" ).checkValidity()) {
					document.getElementById( "group-management-edit-user-frm" ).reportValidity();
					return;
				}
			}

			if ($( _currentTarget ).attr( 'id' ) === "group-id" && $( _currentTarget ).val() == 0) {
				return;
			}
			if ($( _currentTarget ).attr( 'id' ) === "uo-group-report-course" && $( _currentTarget ).val() == 0) {
				return;
			}

			// Sometimes wp editor doesn't update the textarea input rigth way.
			// Let's save iFrame editors to textarea so we can serialize
			if (typeof tinymce !== 'undefined') {
				for (edId in tinyMCE.editors) {
					if (
						typeof tinyMCE.editors[edId] !== 'undefined' &&
						typeof tinyMCE.editors[edId].save !== 'undefined' &&
						tinyMCE.editors[edId].save instanceof Function) {
						tinyMCE.editors[edId].save();
					}
				}

			}

			// Create object that will save the data that's
			// going to be send to the AJAX call
			var restData = {};

			// Get the fields
			var fields = associatedForm.find( ':input' );

			// Get an array of objects with the name and value of the fields,
			// iterate each element, and add it to the restData object,
			// using the field name as the key, and field value as the value
			$.each( fields.serializeArray(), function ( index, field ){
				restData[field.name] = field.value;
			} );

			if (endPoint == 'email_users') {
				restData = fields.serializeArray();
			}

			spinner.show();

			if ('upload_users' === endPoint) {
				uploadedUsers = 0;
			}

			ulgmGroupManagement.restForms.makeAjaxCall( endPoint, restData, associatedForm );

		}
	};

	/**
	 * Extend serialize array to create a serialized object. This is the format that the rest call expects
	 *
	 * @returns object Returns key value pairs where the key is the input name and the value is the input value
	 */
	// Extend serialize array to create an serialized object
	$.fn.serializeObject = function (){
		var o = {};
		var a = this.serializeArray();
		$.each( a, function (){
			if (o[this.name] !== undefined) {
				if (!o[this.name].push) {
					o[this.name] = [o[this.name]];
				}
				o[this.name].push( this.value || '' );
			} else {
				o[this.name] = this.value || '';
			}
		} );
		return o;
	};


} )( jQuery );
